import React from 'react';

import { useModal } from 'hooks/useModal';

import { MoreItems } from 'components/MoreItems';

import MoreItemsButton from './MoreItemsButton';

const MoreItemsButtonContainer = ({
  courses,
  item,
  ...restProps
}: { courses: any; item: any } & Record<string, any>) => {
  const [moreItemsOpen, openMoreItems, closeMoreItems] = useModal({
    defaultOpen: false,
  });

  const handleClick = (event: any) => {
    event.stopPropagation();
    event.preventDefault();

    openMoreItems();
  };

  return (
    <>
      <MoreItemsButton {...restProps} onClick={handleClick} />
      <MoreItems
        open={moreItemsOpen}
        courses={courses}
        item={item}
        onClose={closeMoreItems}
      />
    </>
  );
};

export default React.memo(MoreItemsButtonContainer) as any;
